import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { translate } from 'react-polyglot'
import SaleExport from '../../../components/dossiers/sales/SaleExport'
import { fetchSalesExport, fetchSalesExportHistorical } from '../../../actions/dossier/sales'
import { setActiveSection } from '../../../actions/dossier/common/buttonsSidebar'
import { openModal as openCommonModal } from '../../../actions/common'
import TrackingContainer from '../../tracking/trackingContainer'

export function mapStateToProps (state) {
  return {
    combos: state.combos
  }
}

export function mapDispatchToProps (dispatch) {
  return {
    actions: bindActionCreators({
      fetchSalesExport,
      fetchSalesExportHistorical,
      setActiveSection,
      openCommonModal
    }, dispatch)
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(translate()(TrackingContainer(SaleExport, true)))
